// extracted by mini-css-extract-plugin
export default {"btnIcon":"styles_btnIcon__NtLCB"};